
import store from '@sl/base/store';

export class Winning {
    constructor(scene) {
        this.scene = scene;
        this.timeoutBetweenRow = 1000;
        this.timers = [];
        this.tweenTimers = [];
        this.callback = undefined;
        this.numbersOffsetX = 0;
        this.fadeOutUnluckySymbols = true;
    }

    play(callback) {
        this.removeTimers();
        this.callback = callback;

        if(this.scene.request.totalAmountWon) {
            store.commit('setTotalAmountWon', this.scene.request.totalAmountWon);
        }

        if(!this.scene.request.scenario 
            || (this.scene.request.stepScenario && this.scene.request.stepScenario.bonus_stage) 
            || this.scene.request.scenario.bonus_stage
            || (this.scene.request.scenario.matches && !this.scene.request.scenario.matches.length)) {
            this.doCallback();

            return;
        }
        
        this.scene.skip = false;
        this.scene.showWinning();
    }

    playPaylines() {
        let timeout = 0;

        if(this.scene.request.scenario.amount_won) {
            store.commit('setAmountWon', this.scene.request.scenario.amount_won);
        }
        if(typeof this.scene.winningsMask === 'function') {
            this.scene.winningsMask();
        }

        if(this.scene.request.scenario.matches) {
            const matches = Object.entries(this.scene.request.scenario.matches);
            
            for(const [ matchIndex, match ] of matches) {
                let timer = this.scene.time.delayedCall(timeout, this.playRow, [matchIndex, match], this);
                this.timers.push(timer);
                timeout += this.timeoutBetweenRow;
            }
    
            if(timeout) {
                timeout += this.timeoutBetweenRow;
            } 
    
            let timer = this.scene.time.delayedCall(timeout, this.continue, {}, this);
    
            this.timers.push(timer);
        }
    }

    playRow(matchIndex, match) {
        this.scene.payline.hidePaylines();

        if(this.scene.slots.spinStarted) {
            return;
        }

        if(this.fadeOutUnluckySymbols) {
            this.scene.slots.changeOpacityOfSymbols(0);
            this.scene.slots.changeOpacityOfSymbols(0.5, true);
        }

        if(typeof this.scene.symbolsFader === 'function') {
            this.scene.symbolsFader();
        }

        if(!Config.settings.skip_paylines_animation && match.line) {
            this.scene.payline.showPayline(match.line);
        }

        let symbolObject;

        for(const [ locationIndex, location ] of Object.entries(match.locations)) {
            symbolObject = this.scene.slots.reelsContainersObjects[location.reel_index].symbols[location.absolute_y];

            if(symbolObject.appended) {
                symbolObject.append_parent.alpha = 1;
                symbolObject.append_parent.anims.play(`${symbolObject.append_parent.texture.key}`);
            } else {
                symbolObject.alpha = 1;
                symbolObject.anims.play(`${symbolObject.texture.key}`);
            }

            const reelIndex = location.reel_index;

            if(!Config.settings.payline_to_top) {
                this.scene.slots.reelsContainer.bringToTop(symbolObject);

                if(typeof this.scene.smallFramesLayerUp === 'function') {
                    this.scene.smallFramesLayerUp(reelIndex, symbolObject.positionOnReel);
                }

                if(typeof this.scene.disableLuckySymbolFader === 'function') {
                    this.scene.disableLuckySymbolFader(location.reel_index, symbolObject);
                }
            }
        }

        if(typeof this.scene.customPaylineSound === 'function') {
            this.scene.customPaylineSound(symbolObject);
        } else {
            this.scene.playWinlineSound();
        }

        if(typeof this.scene.winningOnPayline === 'function') {
            const payline = this.scene.payline.paylines[match.line];
            this.scene.winningOnPayline(payline, match);
        }

        if (typeof this.scene.additionalWinningEffect === 'function') { 
            this.scene.additionalWinningEffect(Object.entries(match.locations));
        }

        if((Config.settings.skip_paylines_animation || Config.settings.mark_all_payline_symbols) && match.line) {
            for(const [ reelIndex, symbolAbsolutePosition ] of Object.entries(Config.paylines[match.line])) {
                const symbolObject = this.scene.slots.getSymbolOnReelPosition(reelIndex, symbolAbsolutePosition);
                if(symbolObject.appended) {
                    symbolObject.append_parent.alpha = 1;
                } else {
                    symbolObject.alpha = 1;
                }
            }
        }
    }

    removeTimers() {
        for(const [ timerIndex, timer ] of Object.entries(this.tweenTimers)) {
            if(timer) {
                timer.remove();
            }

            delete this.tweenTimers[timerIndex];
        }
        
        for(const [ timerIndex, timer ] of Object.entries(this.timers)) {
            timer.remove();
            delete this.timers[timerIndex];
        }

        if(typeof this.scene.destroySymbolsFader === 'function') {
            this.scene.destroySymbolsFader();
        }

        if(typeof this.scene.destroyWinningsMask === 'function') {
            this.scene.destroyWinningsMask();
        }

        if(typeof this.scene.destroyWinningOnPayline === 'function') {
            this.scene.destroyWinningOnPayline();
        }

        this.scene.payline.hidePaylines();
        this.scene.hideWinTable();
        this.scene.slots.changeOpacityOfSymbols(1);
    }

    continue() {
        if(this.scene.slots.spinStarted) {
            return;
        }
        
        this.scene.payline.hidePaylines();
        this.removeTimers();

        this.doCallback();
    }

    skip() {
        this.scene.skipAnimations();
    }

    doCallback() {
        this.scene.slots.changeOpacityOfSymbols(1);

        if(this.callback) {
            this.callback();
        }

        this.callback = undefined;
    }

    createWinningFromSprites(number, scale, skin, customOffsetX) {
        let amountSymbolsCount = String(number).trim();
        let container = this.scene.add.container();
        let amount;
        let items = [];
        let offsetX = this.numbersOffsetX;

        if(customOffsetX) {
            offsetX = customOffsetX;
        }

        for (let i = 0; i < amountSymbolsCount.length; i++) {
            let spriteName = amountSymbolsCount[i];
            let separator = false;
            let anchorY = 0.5;

            switch(amountSymbolsCount[i]) {
                case '.':
                    spriteName = 'dot';
                    separator = true;
                    anchorY = 1;
                    break;
                case ',':
                    spriteName = 'comma';
                    separator = true;
                    break;
            }

            if(skin) {
                spriteName += skin;
            }

            amount = this.scene.add.sprite(0, 0, spriteName).setOrigin(0.5, anchorY);
            amount.setScale(scale);

            if(i > 0) {
                amount.x = (prevAmount.x + prevAmount.displayWidth / 2 + amount.displayWidth / 2) + offsetX;
            }

            if(separator) {
                amount.y = prevAmount.y + prevAmount.displayHeight / 2;
            }

            container.add(amount);

            let prevAmount = amount;
            items.push(amount);
        }

        let minusOffsetX = amount.x / 2;
        let minusOffsetY = amount.y / 2;

        items.forEach((value) => {
            value.x -= minusOffsetX;
            value.y -= minusOffsetY;
        });

        container.setSize(amount.x, amount.height);

        return container;
    }
}